import { AnyAction } from 'redux'
import { DetailPageActionTypes } from './constants'
import { actionOnGetYourDevicesSettingsPage, GetYourDevicesSettingsPageInputWithoutContext } from '../utils/wps'
import { normalizeGetDevices, NormalizeGetDevicesType } from '../data/normalize'

export interface IGetDevicesAction extends AnyAction {
  type: typeof DetailPageActionTypes.GetDevices
  input: GetYourDevicesSettingsPageInputWithoutContext
  output: NormalizeGetDevicesType
}

export const getDevicesList = (
  input: GetYourDevicesSettingsPageInputWithoutContext
) =>
  actionOnGetYourDevicesSettingsPage(input, output => ({
    type: DetailPageActionTypes.GetDevices,
    input,
    output: normalizeGetDevices(output),
  }))
